import axios from 'axios';
import PartnersEditar from '../types/PartnersEditar';

async function InsertarPartner(PartnerNuevo: PartnersEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_partner";
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "partner": {
                    "cuit": PartnerNuevo.cuit,
                    "razonsocial": PartnerNuevo.razonsocial,
                    "domicilio": PartnerNuevo.domicilio,
                    "telefono": PartnerNuevo.telefono,
                    "whatsapp": PartnerNuevo.whatsapp,
                    "web": PartnerNuevo.web,
                    "habilitado": PartnerNuevo.habilitado,
                    "mostrar_web": PartnerNuevo.mostrar_web,
                    "fchalta": PartnerNuevo.fchalta,
                    "fchmodificado": PartnerNuevo.fchmodificado,
                    "dado_baja": PartnerNuevo.dado_baja,
                    "fchbaja": PartnerNuevo.fchbaja,
                    "logo_mime": PartnerNuevo.logo_mime,
                    "logo_content": PartnerNuevo.logo_content,
                    "logo_name": PartnerNuevo.logo_name
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarPartner;